// Presentation only. Approval and ticket availability always come from the checkout flow.
const amount = value => value === null || value === undefined || value === '' || !Number.isFinite(Number(value)) ? null : Number(value)

export function receiptMoney(value, currency) {
  const number = amount(value)
  if (number === null) return ''
  return new Intl.NumberFormat('es-EC', currency ? { style: 'currency', currency } : { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(number)
}

export function buildPurchaseReceipt({ event = {}, invoice = null, provider = '', paymentType = '', date = '', shortDate = '', time = '', timeZone = '' } = {}) {
  const snapshot = invoice?.pricing_snapshot || {}
  const currencyCandidate = String(snapshot.currency || event.presentment_currency || '').toUpperCase()
  const currency = /^[A-Z]{3}$/.test(currencyCandidate) ? currencyCandidate : ''
  const products = event.event_eventticket || []
  const items = []
  for (const row of invoice?.invoice_items || []) {
    const quantity = Number(row.quantity)
    if (!Number.isInteger(quantity) || quantity <= 0) continue
    const product = typeof row.product === 'object' ? row.product : products.find(product => String(product.id) === String(row.product))
    const name = product?.name || 'Entrada'
    const unitPrice = amount(row.amount)
    const key = `${product?.id || row.product}:${name}:${unitPrice}`
    const existing = items.find(item => item.key === key)
    if (existing) existing.quantity += quantity
    else items.push({ key, name, quantity, unitPrice })
  }
  const option = (event.payment_options || []).find(option => String(option.id) === String(invoice?.payment_option))
  const rawPaymentLabel = option?.pricing_profile?.label || option?.name || ''
  const paymentLabel = ['stripe', 'rebill'].includes(provider) || /stripe|rebill/i.test(rawPaymentLabel)
    ? 'Tarjeta de crédito o débito'
    : String(paymentType) === '2' ? 'Transferencia bancaria' : rawPaymentLabel
  const fees = amount(snapshot.customer_fee)
  const breakdown = []
  const add = (label, value, nonzero = false) => {
    const number = amount(value)
    if (number !== null && (!nonzero || number !== 0)) breakdown.push({ label, value: number })
  }
  add('Subtotal', invoice?.subtotal)
  add('Impuestos incluidos', invoice?.taxes, true)
  add('Adicionales', invoice?.addons_total, true)
  // The invoice fee can be paid by the organizer. Show the customer's actual fee.
  add('Fee de servicio', fees === null ? invoice?.fee : fees)
  if (amount(invoice?.discount) > 0) add('Descuento', -Number(invoice.discount))
  const city = event.venue?.city?.name || event.city_detail?.name || event.city?.name || ''
  return {
    number: invoice?.id ? `FOMO-${invoice.id}` : '',
    event: event.name || 'Tu evento', category: event.category?.name || '',
    venue: event.venue?.name || '', city, date, shortDate, time, timeZone, currency,
    items: items.map(item => ({ ...item, total: item.unitPrice === null ? null : item.unitPrice * item.quantity })),
    ticketCount: items.reduce((sum, item) => sum + item.quantity, 0),
    breakdown, total: amount(invoice?.total), paymentLabel,
  }
}
